module.exports = __webpack_public_path__ + "fonts/EMprint-Bold.b0ecc617.ttf";